import { Component } from '@angular/core';
import { CanActivateService } from '../../Services/CanActivate/can-activate.service';
import { AuthService } from '../../Services/Auth/auth.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-credential-library',
    templateUrl: './credential-library.component.html',
    styleUrls: ['./credential-library.component.scss'],
    standalone: false
})
export class CredentialLibraryComponent {
  companyAccountId: string | undefined;
  hasCompany!: boolean;
  isInternalUser!: boolean;
  private unsubscribe$ = new Subject<void>();
  isTechSupportInternalUser!: boolean;
  isInternalAdminUser!: boolean;
  isExternalUser!: boolean;
  isTechSupportExternalUser!: boolean;
  isCredLibraryUser!: boolean;
  constructor(
    private canActivate: CanActivateService,
    private auth: AuthService
  ) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    this.canActivate.companyProfile$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((companyProfile) => {
        this.companyAccountId = companyProfile?.companyAccountId;
        this.hasCompany = !!this.companyAccountId;
      });
    this.auth.userProfile$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((userProfile) => {
        if (userProfile) {
          // Check if the user is internal
          this.isInternalUser =
            userProfile['http://allegion.com/claims/user_type'] === 'internal';
          this.isExternalUser =
            userProfile['http://allegion.com/claims/user_type'] === 'external';

          // Now, separately determine if they are a TechSupport role; this is irrespective of being internal or external
          const roles = userProfile['http://allegion.com/claims/roles'] || [];
          this.isTechSupportInternalUser =
            this.isInternalUser &&
            (roles.includes('TechSupport') ||
              roles.includes('Onboarding') ||
              roles.includes('InternalAdmin'));
          this.isTechSupportExternalUser =
            this.isExternalUser &&
            (roles.includes('TechSupport') ||
              roles.includes('Onboarding') ||
              roles.includes('InternalAdmin'));

          this.isCredLibraryUser =
            roles.includes('APIUser') ||
            roles.includes('MobileCredUser') ||
            roles.includes('FullControl') ||
            roles.includes('ViewOnly') ||
            roles.includes('InternalAdmin');
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
